import React, { Component } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import MonitoringsTaskTripsList from "./MonitoringsTaskTripsList";
import { withMonitoringTaskTrips } from "../../../../shared/containers/containerLogisticMonitoringsTaskTrips";

class MonitoringsTaskTripsListWrapper extends Component {
  render() {
    return (
      <Scrollbars style={{ height: `${window.innerHeight - 200}px` }} autoHide={true} ref="scrollbars">
        <MonitoringsTaskTripsList />
      </Scrollbars>
    );
  }
}

export default withMonitoringTaskTrips(React.memo(MonitoringsTaskTripsListWrapper));
